import { random } from '@lib/utils';

import type { Feature, Point } from 'geojson';
import type { ComponentProps } from 'react';
import type { PropertyInfo } from '@components/PropertyInfoPopup/PropertyInfo';

export type PropertyFeature = Feature<Point, PropertyProps>;

type PropertyProps = {
  address: string;
  etage: number;
  price: number;
  priceSqM: number;
  onlineSince: string;
  rooms: number;
  sqM: number;
  img?: string;
};

type PropertyInfoProps = ComponentProps<typeof PropertyInfo>;

export function preparePropertiesDataForPopup({
  address,
  etage,
  price,
  priceSqM,
  onlineSince,
  rooms,
  sqM,
  img,
}: PropertyProps): PropertyInfoProps {
  return {
    address,
    highlights: [`${sqM} m²`, `${rooms} Zimmer`, etage === 0 ? 'Erdgeschoss' : `Etage ${etage}`],
    price,
    priceSqM,
    onlineSince,
    img,
  };
}

export function randomString(min: number, max: number): string {
  return Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(0, random(min, max) | 0);
}
